import type { StudentWorkspaceRoutes } from 'ulanano-cms-api/routes/student-workspace'
import { createGranularTreaty } from '../api-factory'

export const studentWorkspaceApi = createGranularTreaty<StudentWorkspaceRoutes>({ withCookies: true })
